import { css } from 'linaria';

export const cartImageItemStyle = css`
  
        
           /* height: 35px!important; */
           width: 50px!important;
         }
       `;
